import React, { useEffect, useState } from "react";
import DateRangePicker from "components/common/DateRangePicker";
import MultiSelect from "components/common/MultiSelect";
import { Icons } from "assets/icons";
import { DASHBOARD_TABS } from "utils/dashboardUtils"; // Import DASHBOARD_TABS
import { useTranslation } from "react-i18next";

const FILTERS = ["DAY", "WEEK", "MONTH", "YEAR"];

const DashboardFilter = ({
  dates,
  setDates,
  filters = [],
  selectedFilters = {},
  setSelectedFilters = () => {},
  activeTabKey, // Add this prop
}) => {
  
  const [active, setActive] = useState("");
  const [manualDateChange, setManualDateChange] = useState(false);
  const { t } = useTranslation();

  const { refresh, refreshDashboard } = Icons || {};

  const applyPreset = (type) => {
    const now = new Date();
    let from, to;

    switch (type) {
      case "DAY":
        from = new Date();
        from.setHours(0, 0, 0, 0);
        to = new Date();
        break;

      case "WEEK": {
        const w = new Date();
        const day = w.getDay();
        from = new Date(w);
        from.setDate(w.getDate() - day);
        from.setHours(0, 0, 0, 0);
        to = new Date();
        break;
      }

      case "MONTH":
        from = new Date(now.getFullYear(), now.getMonth(), 1);
        to = new Date();
        break;

      case "YEAR":
        from = new Date(now.getFullYear(), 0, 1);
        to = new Date();
        break;

      default:
        from="";
        to="";
        return;
    }

    setActive(type);
    setDates([from, to]);
    setManualDateChange(false);
  };

  const handleFilterChange = (key, value) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleReset = () => {
    setDates([]);
    setActive("");
    setSelectedFilters({});
  };


  useEffect(() => {
    if (dates?.length === 2 && manualDateChange) {
      setActive("");
    }
  }, [dates, manualDateChange]);

  // Filter to show only branch dropdown for Overview tab
  const visibleFilters = filters.filter((filter) => {
    if (filter.key === "branches") {
      return activeTabKey === DASHBOARD_TABS.OVERVIEW.key;
    }
    return true; // Show other filters for all tabs
  });

  return (
    <div className="dashboard_filter g_end gap-2 common_filter">
      {/* Preset buttons */}
      <div className="filter_buttons">
        <label htmlFor="" className="dashboard_filter_label">
          {t("Select Type")}
        </label>
        <div className="type_buttons_wrapper">
          {FILTERS.map((item) => (
            <button
              key={item}
              className={`main_btn ${active === item ? "active" : ""}`}
              onClick={() => applyPreset(item)}
            >
              {item.charAt(0) + item.slice(1).toLowerCase()}
            </button>
          ))}
        </div>
      </div>

      {/* Date picker */}
      <div className="position_relative date_picker_wrapper">
        <label htmlFor="" className="dashboard_filter_label">
          {t("Select Date")}
        </label>
        <DateRangePicker dates={dates} setDates={setDates} />
      </div>
      {/* Dashboard MultiSelect - Only show for relevant tabs */}
      {visibleFilters.length > 0 && (
        <>
          <div className="position_relative store_wrapper">
            <label htmlFor="" className="dashboard_filter_label">
              {t("Select Store")}
            </label>
            {visibleFilters.map((filter) => (
              <MultiSelect
                key={filter.key}
                value={selectedFilters[filter.key] || []}
                options={filter.options}
                placeholder={filter.placeholder}
                onChange={(val) => handleFilterChange(filter.key, val)}
                hideError
              />
            ))}
          </div>
        </>
      )}

      <button
        className="main_btn reset-filter"
        type="button"
        onClick={handleReset}
      >
        <img src={refreshDashboard} width={20} height={20} alt="search" />
      </button>
    </div>
  );
};

export default DashboardFilter;
